import React from "react";
import { CRMIcon } from "../../CRMIcon/CRMIcon";
import { CRMColors } from "../../../models/CRMColors";

type TCRMCaseLinkedMatterBannerProps = {
    direction: "successor" | "predecessor";
    linkedCaseId: string;
};

const copyFor = (direction: TCRMCaseLinkedMatterBannerProps["direction"]) =>
    direction === "successor"
        ? {
            title: "This sale fell through",
            body: "The work moved to a new case.",
            link: "Open the new case",
        }
        : {
            title: "This case replaced an earlier one",
            body: "The last sale fell through. The work was moved here.",
            link: "Open the old case",
        };

export const CRMCaseLinkedMatterBanner = (props: TCRMCaseLinkedMatterBannerProps): JSX.Element => {
    const copy = copyFor(props.direction);

    return (
        <div className="crm-case-linked-matter-banner">
            <div className="crm-case-linked-matter-banner__icon">
                <CRMIcon
                    iconName="arrow-right"
                    size="20px"
                    colour="hex"
                    hexColour={CRMColors.NEUTRAL_2}
                />
            </div>

            <div className="crm-case-linked-matter-banner__body">
                <div className="crm-case-linked-matter-banner__title">
                    {copy.title}
                </div>
                <div className="crm-case-linked-matter-banner__text">
                    {copy.body}
                </div>
                <a
                    className="crm-case-linked-matter-banner__link"
                    href={`/crm/legal/cases/${props.linkedCaseId}`}
                >
                    {copy.link}
                </a>
            </div>
        </div>
    );
};
